import { render, staticRenderFns } from "./ScoreSelector.vue?vue&type=template&id=aba0d200&scoped=true&"
import script from "./ScoreSelector.vue?vue&type=script&lang=ts&"
export * from "./ScoreSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ScoreSelector.vue?vue&type=style&index=0&id=aba0d200&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0d200",
  null
  
)

export default component.exports